import React, { FC, useState, useCallback } from 'react';
import {
    Outlet,
    ScrollRestoration,
    useLocation,
    matchPath,
} from 'react-router-dom';
import GlobalFooter from './GlobalFooter';
import './Layout.scss';
import SideBar from '../reusables/SideBar';
import { AppRoutes } from '../../Constants';

type LayoutProps = { children?: JSX.Element };

const Layout: FC<LayoutProps> = () => {
    const location = useLocation();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

    const SHOW_LAYOUT = [
        AppRoutes.FixedAsset,
        AppRoutes.ProjectData,
        AppRoutes.TaxPools,
        AppRoutes.Rules,
        AppRoutes.Reporting,
        AppRoutes.Log,
    ];

    const showLayout = SHOW_LAYOUT.some((pattern) =>
        matchPath({ path: pattern, end: false }, location.pathname)
    );

    const hideFooter =
        location.pathname === AppRoutes.LogoutPage ||
        location.pathname === AppRoutes.HomePage;

    const handleSidebarToggle = useCallback((collapsed: boolean) => {
        setIsSidebarCollapsed(collapsed);
    }, []);

    return (
        <div className="global-layout">
            <div id="nav-portal" />

            <div className="main-layout">
                {showLayout && (
                    <aside
                        className={
                            isSidebarCollapsed
                                ? 'sidebar sidebar--collapsed'
                                : 'sidebar'
                        }
                    >
                        <SideBar onToggle={handleSidebarToggle} />
                    </aside>
                )}

                {/* Only scrollable region */}
                <main role="main" className="outlet-container">
                    <Outlet />
                </main>
            </div>

            {!hideFooter && <GlobalFooter />}

            <ScrollRestoration />
        </div>
    );
};

export default Layout;
